import React, {Component} from 'react';
import {message} from 'antd';

import {queryIncuSettledInfo} from '@api/incubator/settled';
import localDb from '@util/localDb';

import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getIncuSettledInfo();
  }

  getIncuSettledInfo = () => {
    queryIncuSettledInfo({
      uuid: this.props.params.settledUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        const { payables = [] } = res.data;
        payables.map(item => {
          if (item.turns) {
            item.turns = item.turns.map(item2 => {
              return {
                businessUuid: item2.oldBusinessUuid,
                payableUuid: item2.oldPayableUuid,
                payableNo: item2.oldPayableNo,
                price: item2.price,
                uuid: item2.uuid,
              };
            });
          }
          return item;
        });
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return null;
  }
}
export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/incubator/settled/PageInfo.js